<template>
  <div>
    <span class="link" v-if="userInfo.Role == 'Admin'" @click="confirmChangeRecord">{{ (params.value === 1)? 'Hide' : 'Show' }}</span>
    <span class="link" v-if="((userInfo.Role != 'Partner Admin') && (userInfo.Role != 'Admin'))" @click="confirmChangeRecord">{{params.value}} | {{ (params.value === 1)? 'Hide' : 'Show' }}</span>
    <span class="link" v-if="userInfo.Role == 'Partner Admin'">{{params.value}}</span>
  </div>
</template>

<script>

import PrepayService from "@/services/PrepayService";
import UtilService from "@/services/UtilService";

export default {
  name: 'CellRendererStatus',
  methods: {
    confirmChangeRecord () {
      const text = ('Are you sure to ' + ((this.params.value)? 'show?' : 'hide?'));
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirm',
        text: text,
        accept: this.changeIsHidden,
        acceptText: 'Yes'
      })
    },
    changeIsHidden () {
      let prepayObj = {...this.params.data};
      prepayObj['IsHidden'] = (this.params.value === 1)? 0 : 1;
      prepayObj['Partner'] = prepayObj['PartnerId'];
      delete prepayObj['PartnerId'];
      PrepayService.update(prepayObj.Id, prepayObj)
        .then(() => {
          UtilService.notifySuccessAlert(this.$vs, 'Prepay record successfully updated.');
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
  }
}
</script>

<style lang="scss" scpoped>
.link{
  cursor: pointer;
  color: #7367f0;
}
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>


